import AbstractController from './AbstractController';

export default class Default extends AbstractController {
}
